import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { PaletteRoles } from '../../types'
import { ROLE_FIELDS } from './palettes'

/** Five swatches in role order. */
export function Swatches({ colors, className }: { colors: PaletteRoles; className?: string }) {
  return (
    <div className={cn('flex h-8 overflow-hidden rounded-md border', className)}>
      {ROLE_FIELDS.map(({ key }) => (
        <div key={key} className="flex-1" style={{ background: colors[key] }} />
      ))}
    </div>
  )
}

/** A palette to try: clicking it previews it on the page immediately. */
export function PaletteCard({
  name,
  description,
  colors,
  selected,
  badge,
  onSelect,
}: {
  name: string
  description?: string
  colors: PaletteRoles
  selected: boolean
  badge?: string
  onSelect: () => void
}) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={cn(
        'space-y-2 rounded-lg border p-3 text-left transition-colors',
        selected ? 'border-primary ring-1 ring-primary' : 'hover:bg-accent/50',
      )}
    >
      <Swatches colors={colors} />
      <div className="flex items-center gap-2">
        {selected && (
          <span className="rounded-full bg-primary p-0.5 text-primary-foreground">
            <Check className="h-3 w-3" />
          </span>
        )}
        <p className="text-sm font-medium">{name}</p>
        {badge && (
          <span className="rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-primary">
            {badge}
          </span>
        )}
      </div>
      {description && <p className="text-xs text-muted-foreground">{description}</p>}
    </button>
  )
}
